var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8789 5.22754C26.1872 5.22754 19.1289 12.2858 19.1289 20.9775C19.1289 29.6715 26.1872 36.7275 34.8789 36.7275C43.5707 36.7275 50.6289 29.6715 50.6289 20.9775C50.6289 12.2858 43.5707 5.22754 34.8789 5.22754ZM34.8789 9.72754C41.0889 9.72754 46.1289 14.7698 46.1289 20.9775C46.1289 27.1875 41.0889 32.2275 34.8789 32.2275C28.6689 32.2275 23.6289 27.1875 23.6289 20.9775C23.6289 14.7698 28.6689 9.72754 34.8789 9.72754Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87891 63.7275H36.0017C37.2437 63.7275 38.2517 64.7355 38.2517 65.9775C38.2517 67.2195 37.2437 68.2275 36.0017 68.2275H5.62891C4.38691 68.2275 3.37891 67.2195 3.37891 65.9775C3.37891 65.9775 3.37891 64.1235 3.37891 61.4775C3.37891 50.295 12.4442 41.2275 23.6289 41.2275H36.0017C37.2437 41.2275 38.2517 42.2355 38.2517 43.4775C38.2517 44.7195 37.2437 45.7275 36.0017 45.7275H23.6289C14.9304 45.7275 7.87891 52.779 7.87891 61.4775V63.7275Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0056 41.2275C45.9348 41.2275 39.3828 47.7795 39.3828 55.8503C39.3828 63.921 45.9348 70.473 54.0056 70.473C62.0763 70.473 68.6283 63.921 68.6283 55.8503C68.6283 47.7795 62.0763 41.2275 54.0056 41.2275ZM54.0056 45.7275C59.5923 45.7275 64.1283 50.2635 64.1283 55.8503C64.1283 61.437 59.5923 65.973 54.0056 65.973C48.4188 65.973 43.8828 61.437 43.8828 55.8503C43.8828 50.2635 48.4188 45.7275 54.0056 45.7275Z",
    fill: "#F30002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.148 45.5029L43.6542 62.9966C42.7767 63.8741 42.7767 65.3006 43.6542 66.1781C44.5317 67.0579 45.9582 67.0579 46.8357 66.1781L64.3295 48.6844C65.2092 47.8069 65.2092 46.3804 64.3295 45.5029C63.452 44.6254 62.0255 44.6254 61.148 45.5029Z",
    fill: "#F30002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockUser);
export default __webpack_public_path__ + "static/media/block-user.3ef307be577db36726eb905a79628a01.svg";
export { ForwardRef as ReactComponent };